module.exports = __webpack_public_path__ + "static/DRON_01-tablet-033ffc487c93b4f9e2f1442df928376b.jpg";